<template>
  <v-app>
 <div id="app">
    <AppHeader v-if="!shouldHideHeader" />
    <v-main>
      <div class="app-content">
        <InactivityWarningModal
          v-if="showWarning"
          :remaining-seconds="remainingSeconds"
          @stay-logged-in="handleStayLoggedIn"
          @logout="forceLogout"
        />
        <LoaderVue />
        
          <router-view /> 
      </div>
    </v-main>
  </div>
  </v-app>
 
</template>

<script setup>
import { computed, onMounted, onUnmounted, watch} from 'vue'
import { useRoute } from 'vue-router'
import AppHeader from './views/AppHeader.vue'
import LoaderVue from "./components/reusable/Loader.vue"
import InactivityWarningModal from './views/InactivityWarningModal.vue'
import { useInactivityTracker } from '@/composables/useInactivityTracker'
import { useUserStore } from '@/store/user'
import {usePathController} from "@/composables/usePathController"
import {useLogger} from "@/composables/useLogger"
const {sendLog} = useLogger() 

const { logoutCoordinator } = usePathController()
const route = useRoute()
const {
  showWarning,
  remainingSeconds,
  handleStayLoggedIn,
  forceLogout,
  registerActivity
} = useInactivityTracker()

const shouldHideHeader = computed(() => route.meta.hideHeader === true)

const userStore = useUserStore()


onMounted(() => {
  const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart']
  events.forEach(e =>
    document.addEventListener(e, registerActivity, { passive: true })
  )
})

onUnmounted(() => {
  // Cleanup when app unmounts (rare)
  const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart']
  events.forEach(event => {
    document.removeEventListener(event, registerActivity)
  })
})

</script>

<style src="./assets/styles.css"></style>
